var React = require('react');

function IconInfoCircleO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M955.6 510.6c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.3 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z","key":0}),React.createElement("path",{"d":"M417.1 732h189.6v-53.7h-68.3V414.5l-121.3.7v53.7h68.3v209.4h-68.3z","key":1}),React.createElement("ellipse",{"cx":"511.9","cy":"327.6","rx":"43.1","ry":"43.2","key":2})]);
}

IconInfoCircleO.displayName = "IconInfoCircleO";

IconInfoCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconInfoCircleO;

IconInfoCircleO.default = IconInfoCircleO;
